const Sizes = {
  Text: {
    h1: "120px",
    h2: "48px",
    h3: "32px",
    h4: "28px",
    h5: "26px",
    p: "24px",
  },
};

export { Sizes };
